<span class="sr-only" aria-live="polite" role="status">{{ announcement }}</span>

<div class="isl-wrap" *ngIf="visible" [style.left.px]="left" [style.right.px]="right">
  <section
    class="isl"
    [class.is-open]="expanded && !showSuccess"
    [class.isl--success]="showSuccess"
    role="region"
    aria-label="Finish setting up"
  >
    <ng-container *ngIf="!showSuccess; else success">
      <div class="isl__panel" id="isl-panel" [attr.inert]="expanded ? null : ''">
        <div class="isl__panel-inner">
          <h2 class="isl__title" #panelTitle tabindex="-1">Finish setting up</h2>
          <p class="isl__progress">{{ doneCount }} of {{ tasks.length }} done</p>
          <div
            class="isl__bar"
            role="progressbar"
            aria-label="Setup progress"
            [attr.aria-valuenow]="doneCount"
            aria-valuemin="0"
            [attr.aria-valuemax]="tasks.length"
          >
            <span [style.width.%]="progressPercent"></span>
          </div>
          <ul class="isl__list">
            <li *ngFor="let t of tasks; trackBy: trackById" [class.is-done]="t.done">
              <i class="bi" [ngClass]="t.done ? 'bi-check-circle-fill' : 'bi-circle'" aria-hidden="true"></i>
              <span>
                {{ t.label }}
                <span class="sr-only">{{ t.done ? '(done)' : '(not done)' }}</span>
                <small *ngIf="t.sublabel && !t.done">{{ t.sublabel }}</small>
              </span>
            </li>
          </ul>
          <button type="button" class="isl__cta isl__cta--block" (click)="verify()">Verify now</button>
        </div>
      </div>

      <div class="isl__bar-row">
        <button
          #toggleBtnRef
          type="button"
          class="isl__toggle"
          aria-controls="isl-panel"
          [attr.aria-expanded]="expanded"
          [attr.aria-label]="toggleLabel"
          (click)="toggle()"
        >
          <i class="bi bi-whatsapp isl__icon" aria-hidden="true"></i>
          <span class="isl__copy">{{ copy }}</span>
          <span class="isl__count" aria-hidden="true">{{ pendingCount }} left</span>
          <i class="bi isl__chev" [ngClass]="expanded ? 'bi-chevron-down' : 'bi-chevron-up'" aria-hidden="true"></i>
        </button>
        <button type="button" class="isl__cta" *ngIf="!expanded" (click)="verify()">{{ ctaLabel }}</button>
      </div>
    </ng-container>

    <ng-template #success>
      <div class="isl__bar-row isl__bar-row--success">
        <i class="bi bi-check-circle-fill isl__ok" aria-hidden="true"></i>
        <span class="isl__copy">All set. Your coaches can now reach you on WhatsApp.</span>
      </div>
    </ng-template>
  </section>
</div>
